// extracted by mini-css-extract-plugin
module.exports = {"root":"LoaderInterstitial_root__7uEiJ","message":"LoaderInterstitial_message__wB3ej"};